import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IDistrictsApiClient } from './i-districts-api.client';
import {
  ICreateDistrictRequest,
  IDistrictResponse,
  IUpdateDistrictReqeust,
} from '../dtos';
import { districtsData } from '../data/districts.data';
import { ICreateDistrictResponse } from '../dtos/responses/create-districts.response';
import { IPaginationResponse, ISoftDeletablePaginationParameters } from '../../../data-access';


@Injectable({
  providedIn: 'root'
})
export class DistrictsInMemoryApiClient implements IDistrictsApiClient {
  constructor(protected http: HttpClient) {}

  get(
        paginationParameters?: ISoftDeletablePaginationParameters
  ): Observable<IPaginationResponse<IDistrictResponse>> {
    return of(districtsData.districtsResponse);
  }

  getById(id: string): Observable<IDistrictResponse> {
    return of(districtsData.districtResponse);
  }

  create(request: ICreateDistrictRequest): Observable<ICreateDistrictResponse> {
    return of(districtsData.createDistrictResponse);
  }

  update(id: string, request: IUpdateDistrictReqeust): Observable<void> {
    return of();
  }
}
